import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { SimpleDialog } from '../dialog-helper';
import BaseController from '../BaseController';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';

import { Endpoint } from '../../constants/endpoints';
import { DialogType, ModalType, SimpleDialogParams } from '../../interfaces/simple-dialog';

export class EventListenerController {
  static delete: EventListener | undefined;
  static inactivate: EventListener | undefined;
}

export interface DiagnosisResponseDTO {
  sequenceNumber: string;
  status: boolean;
}

export default class DiagnosisService {

  static isAllowEdit = true;

  ownerController: BaseController;

  constructor(ownerController: BaseController) {
    this.ownerController = ownerController;
  }

  delete(patientId: number, encounterId: number, sequence: number): Promise<boolean> {
    return HttpService.delete(Endpoint.DELETE_DIAGNOSIS,{
      encounterId,
      patientId,
      sequence,
    }
    ).then(response => {
      if (response.body === true) {
        applicationContext.popNavigationItem();
        return true;
      }
      return false;
    }).catch((err) => {
      throw err;
    });
  }

  confirmDelete(patientId: number, encounterId: number, sequence: number): void {
    const title       = 'patient-evolution.delete-question-evolution';
    const cancelTitle = 'tws.form.cancel';
    const okTitle     = 'patient-evolution.delete-evolution';

    this.showMessageDialog(
      title,
      title,
      DialogType.ACTION,
      () => { this.defaultDiscard() },
      async () => { await this.delete(patientId, encounterId, sequence) },
      cancelTitle,
      okTitle
    );
  }

  release(patientId: string, sequence: string, encounterId: string): Promise<boolean> {

    return HttpService.put(Endpoint.RELEASE_DIAGNOSIS,{
      encounterId,
      patientId,
      sequence,
    }
    ).then(response => {
      const responseBody = response.body as DiagnosisResponseDTO;
      const status = responseBody.status;

      if (status) {
        applicationContext.popNavigationItem();
        return true;
      }
      return false;
    }).catch((err) => {
      SimpleDialog.showErrorMessage(err);
      return false;
    });
  }

  discardRelease(): void {
    applicationContext.popNavigationItem();
    applicationContext.popNavigationItem();
  }

  inactivate(patientId: number, encounterId: number, sequence: number, justification: string): Promise<boolean> {
    return HttpService.put(Endpoint.INACTIVATE_DIAGNOSIS,{
      encounterId,
      justification,
      patientId,
      sequence,
    }
    ).then(response => {
      const responseBody = response.body as DiagnosisResponseDTO;
      const status = responseBody.status;

      if (status) {
        applicationContext.popNavigationItem();
        applicationContext.popNavigationItem();
        return true;
      }
      return false;
    }).catch((err) => {
      SimpleDialog.showErrorMessage(err);
      return false;
    });
  }

  confirmRelease(patientId: string, sequence: string, encounterId: string): void {
    const title       = 'patient-evolution.release-title-evolution';
    const description = '';
    const cancelTitle = '';
    const okTitle     = 'patient-evolution.release-submit-evolution';

    this.showMessageDialog(
      title,
      description,
      DialogType.ACTION,
      () => {},
      async () => { await this.release(patientId, sequence, encounterId) },
      cancelTitle,
      okTitle
    );
  }

  confirmCancelAndRelease(patientId: string, sequence: string, encounterId: string): void {
    const title       = 'patient-evolution.release-evolution';
    const description = 'patient-evolution.release-title-evolution';
    const cancelTitle = 'patient-evolution.release-cancel-evolution';
    const okTitle     = 'patient-evolution.release-submit-evolution';

    this.showMessageDialog(
      title,
      description,
      DialogType.ACTION,
      () => { this.discardRelease() },
      async () => { await this.release(patientId, sequence, encounterId) },
      cancelTitle,
      okTitle
    );
  }

  defaultDiscard(): void {
    applicationContext.popNavigationItem();
  }

  showMessageDialog(title: string, description: string, dialogType: DialogType, onCancel: () => void, onClickOk: () => void, cancelTitle: string, okTitle: string): void {
    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: description,
      dialogType: dialogType,
      modalType: ModalType.DIALOG,
      onClickCancel: onCancel,
      onClickOk: onClickOk,
      titleDialog: title,
      titleOnCancel: cancelTitle,
      titleOnOk: okTitle,
    }

    SimpleDialog.openDialog(dialogParams);
  }
}

export class DiagnosisContext {
  private static _isInternalNavigation = false;

  public static isInternalNavigation(): boolean {
    return this._isInternalNavigation;
  }

  public static setInternalNavigation(state: boolean): void {
    this._isInternalNavigation = state;
  }
}
